<template>
  <loader v-if="isLoading"/>
  <v-container v-else>
    <v-row>
      <v-flex>
        <div class="d-flex align-center">
          <v-btn text icon @click="() => $router.go(-1)">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <h1>
            {{ $tc('texts.application.label', 1) }} {{ application.job }}
          </h1>
        </div>
      </v-flex>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : ''">
            <v-stepper v-model="step" vertical class="elevation-0">
              <v-stepper-step step="1" complete>
                {{ $t('texts.userData') }}
              </v-stepper-step>
              <v-stepper-content step="1" :class="$vuetify.breakpoint.xsOnly ? 'pa-4 ma-0' : ''">
                <v-card flat>
                  <v-card-text :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : ''">
                    <v-container class="pa-0 ma-0" grid-list-md>
                      <v-row>
                        <v-col :cols="12">
                          <v-card outlined>
                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col :cols="12" :md="8">
                                    <form>
                                      <user-data
                                        :form="userData"
                                      />
                                    </form>
                                  </v-col>
                                  <v-col :cols="12" :md="4">
                                    <user-image
                                      :userImage="userData.image"
                                    />
                                    <v-card flat>
                                      <v-card-text>
                                        {{ $t('texts.profilePicture-size-info') }}<br>
                                        {{ $t('texts.company.profile.images-type-info') }}
                                      </v-card-text>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      v-if="step === 1"
                      color="primary"
                      @click="saveUserData()"
                      :disabled="buttonLoading"
                      :loading="buttonLoading"
                    >
                      {{ $t('texts.next') }}
                      <v-icon right>
                        navigate_next
                      </v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <v-stepper-step step="2" :complete="step > 2">
                {{ $t('texts.resume') }}
              </v-stepper-step>
              <v-stepper-content step="2" :class="$vuetify.breakpoint.xsOnly ? 'pa-1 ma-0' : ''">
                <v-card flat>
                  <v-card-text>
                    <resume-list
                      :hideTitle="true"
                      containerClass="pa-0"
                      :resumeCardsOutlined="true"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      @click.native="step -= 1"
                      text
                    >
                      <v-icon left>
                        navigate_before
                      </v-icon>
                      {{ $t('texts.back') }}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                      color="primary"
                      @click="next()"
                    >
                      {{ $t('texts.next') }}
                      <v-icon right>
                        navigate_next
                      </v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <v-stepper-step step="3" :complete="step > 3">
                {{ $t('texts.applicationLetter') }}
              </v-stepper-step>
              <v-stepper-content step="3" :class="$vuetify.breakpoint.xsOnly ? 'pa-1 ma-0' : ''">
                <v-card flat>
                  <v-card-text>
                    <quill-editor
                      v-model="application.application_letter"
                      ref="myQuillEditor"
                      :options="editorOption"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      @click.native="step -= 1"
                      text
                    >
                      <v-icon left>
                        navigate_before
                      </v-icon>
                      {{ $t('texts.back') }}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                      color="primary"
                      @click="next()"
                    >
                      {{ $t('texts.next') }}
                      <v-icon right>
                        navigate_next
                      </v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-stepper-content>
              <v-stepper-step step="4">
                {{ $t('texts.testing') }}
              </v-stepper-step>
              <v-stepper-content step="4" :class="$vuetify.breakpoint.xsOnly ? 'pa-2 ma-0' : ''">
                <v-alert error :value="isIdenticalEmployer">
                  {{ $t('texts.noCooperationIdenticalCompany', {'company': application.company}) }}
                </v-alert>
                 <v-card flat>
                  <v-card-text>
                    <application-check
                      :application="application"
                      :authUser="userData"
                      :countries="countries"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      @click.native="step -= 1"
                      text
                    >
                      <v-icon left>
                        navigate_before
                      </v-icon>
                      {{ $t('texts.back') }}
                    </v-btn>
                  </v-card-actions>
                 </v-card>
              </v-stepper-content>
            </v-stepper>
          </v-card-text>
          <v-divider/>
          <v-card-actions :class="$vuetify.breakpoint.xsOnly ? 'card__actions--mobile' : ''">
            <v-spacer/>
            <v-btn
              color="secondary"
              @click="saveAsDraft()"
              :disabled="storeApplicationPending"
              :loading="storeApplicationPending && application.status === 'DRAFT'"
            >
              <v-icon left class="white--text">save</v-icon>
              <template v-if="application.id === null">
                {{ $t('texts.saveAsDraft') }}
              </template>
              <template v-else>
                {{ $t('texts.updateDraft') }}
              </template>
            </v-btn>
            <v-btn
              v-if="step === 4"
              color="primary"
              @click="submitApplication()"
              :disabled="storeApplicationPending"
              :loading="storeApplicationPending && application.status === 'SEND'"
            >
              {{ $t('texts.submitApplication') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <confirmation-dialog ref="confirm"  :options="{ width: 500 }"/>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import ResumeList from '@/components/_templates/employee/resume/List.vue';
import UserData from '@/components/_templates/employee/profile/UserData.vue';
import UserImage from '@/components/_templates/employee/profile/UserImage.vue';
import ConfirmationDialog from '@/components/_organisms/ConfirmationDialog.vue';
import ApplicationCheck from './ApplicationCheck.vue';

const { mapState: mapGeneralState, mapActions: mapGeneralActions } = createNamespacedHelpers('general');
const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapState: mapEmployeeState, mapActions: mapEmployeeActions } = createNamespacedHelpers('employee');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'ApplicationEdit',
  components: {
    UserData,
    UserImage,
    ResumeList,
    ApplicationCheck,
    ConfirmationDialog,
  },
  data() {
    return {
      isLoading: false,
      buttonLoading: false,
      draftButtonLoading: false,
      step: 1,
      job: {
        company_id: null,
        start_year: '',
        start_month: '',
      },
      userData: {
        sex: 1,
        first_name: '',
        last_name: '',
        date_of_birth: null,
        email: '',
        nationality: '',
        residence_permit: '',
        language: '',
        street: '',
        street_number: '',
        zip: '',
        place: '',
        country: '',
        phone: '',
        newsletter: false,
      },
      application: {
        id: null,
        job_id: null,
        job: '',
        status: 'DRAFT',
        company: '',
        workload_min: '',
        workload_max: '',
        place: '',
        application_letter: '',
      },
      editorOption: {
        placeholder: this.$i18n.t('texts.editorPlaceholder'),
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
          ],
        },
        formats: [
          'background',
          'bold',
          'color',
          'font',
          'italic',
          'link',
          'size',
          'strike',
          'script',
          'underline',
          'blockquote',
          'header',
          'indent',
          'list',
          'align',
          'direction',
          'formula',
        ],
      },
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  created() {
    this.isLoading = true;

    // Get Application
    const hasApplicationInEdit = Object.keys(this.applicationInEdit).length > 0;
    const applicationAlreadyLoaded = hasApplicationInEdit && parseInt(this.$route.params.id, 10) === parseInt(this.applicationInEdit.id, 10);
    const applicationAlreadyStarted = hasApplicationInEdit && (this.$route.params.job && this.$route.params.job.id === this.applicationInEdit.job_id);
    const isNewApplicationInEdit = hasApplicationInEdit && !this.$route.params.id && !this.$route.params.job;
    if (hasApplicationInEdit && (applicationAlreadyLoaded || applicationAlreadyStarted || isNewApplicationInEdit)) {
      Object.assign(this.application, this.applicationInEdit);
      if (isNewApplicationInEdit) {
        this.step = 2;
      }
    } else if (this.$route.params.id) {
      const application = this.jobApplications.find((item) => item.id === this.$route.params.id);
      if (application) {
        Object.assign(this.application, application);
      }
    } else if (this.$route.params.job) {
      const job = { ...this.$route.params.job };
      Object.assign(this.job, job);
      this.application.job_id = job.id;
      this.application.job = job.title;
      this.application.company = job.company;
      this.application.workload_min = job.workload_min;
      this.application.workload_max = job.workload_max;
      this.application.place = job.place;
    }

    // Set User
    Object.assign(this.userData, this.authUser);

    // Fetch Job
    if (!this.job.id) {
      this.fetchJob(this.application.job_id).then((response) => {
        Object.assign(this.job, response);
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGeneralState([
      'countries',
    ]),
    ...mapUserState([
      'authUser',
    ]),
    ...mapEmployeeState([
      'resume',
      'jobApplications',
      'storeApplicationPending',
      'applicationInEdit',
    ]),
    isIdenticalEmployer() {
      if (
        this.resume.jobs.length > 0
        && this.job.company_id === this.resume.jobs[0].company_id
      ) {
        const latestJob = this.resume.jobs[0];
        const latestJobEndDate = moment([latestJob.end_year, latestJob.end_month - 1, 1]);
        const jobStartDate = moment([this.job.start_year, this.job.start_month - 1, 1]);
        const difference = jobStartDate.diff(latestJobEndDate, 'days');
        return difference > 0 && difference < 125;
      }
      return false;
    },
  },
  methods: {
    ...mapUserActions([
      'updateUserProfile',
    ]),
    ...mapEmployeeActions([
      'storeApplication',
      'saveApplicationInEdit',
    ]),
    ...mapGeneralActions([
      'fetchJob',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    reset() {
      this.step = 1;
      this.job = {
        company_id: null,
        start_year: '',
        start_month: '',
      };
      this.application = {
        id: null,
        job_id: null,
        job: '',
        status: 'DRAFT',
        company: '',
        workload_min: '',
        workload_max: '',
        place: '',
        application_letter: '',
      };
      this.userData = {
        sex: 1,
        first_name: '',
        last_name: '',
        date_of_birth: null,
        email: '',
        nationality: '',
        residence_permit: '',
        language: '',
        street: '',
        street_number: '',
        zip: '',
        place: '',
        country: '',
        phone: '',
        newsletter: false,
      };
    },
    saveUserData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.userData.image = this.authUser.image;
          this.buttonLoading = true;
          this.updateUserProfile(this.userData)
            .then(() => {
              this.buttonLoading = false;
              this.next();
            });
        } else {
          this.showMessageValidateError();
        }
      });
    },
    next() {
      this.step += 1;
    },
    saveAsDraft() {
      this.application.status = 'DRAFT';
      this.storeApplication(this.application).then((response) => {
        Object.assign(this.application, response);
      });
    },
    async submitApplication() {
      const confirmDialog = async () => this.$refs.confirm.open({
        title: 'submitApplication',
        message: 'additionalTextSumbitApplication',
        confirm: 'confirmSubmitApplication',
        reject: 'cancelSubmitApplication',
      });
      if (await confirmDialog()) {
        this.application.status = 'SEND';
        this.storeApplication(this.application).then(() => {
          this.$router.push({ name: 'employee.application.list' });
        });
      }
    },
  },
  beforeDestroy() {
    this.saveApplicationInEdit(this.application);
  },
};
</script>
